import {
    centsParseValue,
    Column,
    Group,
    GroupByProp,
    lookupNestedProp,
    renderCents, RenderFilterProps, sortNumericInner, sortStringInner, universalParser
} from "../../../../misc/scroller/Table";
import React, {useContext, useState} from "react";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {Button, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {TableMoreBtn} from "../openings/RowActions";
import {PriceLine} from "../../../../api/Pricing";
import {QuotePriceLine, QuotePriceRider} from "../../../../api/QuotePricing";
import {hollowMetalDoor, woodDoor} from "../openings/Const";
import {User} from "../../../../api/Users";
import {formatCents} from "nate-react-api-helpers";
import {isNullOrUndefined, parseMarkup} from "../../shopdrawing/pricing/Pricing";
import {blue, blueGrey, grey} from "@mui/material/colors";
import {hasPermission} from "../../../../misc/Permission";
import {MiscPrice} from "../../../../api/MiscPricing";
import {QuoteMiscPrice} from "../../../../api/QuoteMiscPricing";
import {MarkupEditCell2} from "./MarkupEditCell2";
import {BeforeGroup, BeforeGroup2, markupColumnName} from "./BeforeGroup";
import {AfterGroup, AfterGroup2, costEachColumnName, qtyColumnName} from "./AfterGroup";
import {CostFocuser} from "../../shopdrawing/pricing/CostFocuser";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {SelectFilterForCol} from "../../../../misc/SelectFilterForCol";
import {editCellPadding} from "../../../../misc/scroller/TableEditCell";
import {UnitSystem} from "../../../../api/Projects";
import {MetricDistance} from "../../../../misc/MetricDistance";
import {ImperialDistance} from "../../../../misc/ImperialDistance";
import {formatSmallUnits} from "../../../../misc/DimFormat";

export type PriceLine2 = any;

export function getSectionKeyForRiders(key: SectionKey): SectionKey {
    // backward compatibility
    {
        if (key.startsWith("frame-") || key === "frame") {
            return "frame-riders";
        }

        if (key.startsWith("door-")) {
            if (key === "door-wd" || key === "door-riders/wd" || key === "door-prep/wd") return "door-riders/wd" as any;
            return "door-riders/hm" as any;
        }

        if (key.startsWith("hardware-")) {
            return "hardware-riders" as any;
        }

        switch (key) {
            case "div-10/locker": return "div-10/locker-riders" as any;
            case "div-10/mailbox": return "div-10/mailbox-riders" as any;
            case "div-10/corner-guard": return "div-10/corner-guard-riders" as any;
            case "div-10/wr-accessory": return "div-10/wr-accessory-riders" as any;
            case "div-10/wr-partition": return "div-10/wr-partition-riders" as any;
            case "glazing": return "glazing-riders" as any;
        }
    }

    return key;
}

export const commonGroupBy2: GroupByProp<PriceRow> = {
    fixedGroups: [
        "frame", "frame-anchor", "frame-prep", "frame-riders", "frame-totals",
        "door-hm", "door-wd", "door-prep", "door-riders/wd", "door-riders/hm", "door-totals",
        "hardware-before", "hardware-riders", "hardware-after",
        'div-10/corner-guard', 'div-10/locker', 'div-10/mailbox', 'div-10/wr-accessory', 'div-10/wr-partition',
        'div-10/corner-guard-riders', 'div-10/locker-riders', 'div-10/mailbox-riders', 'div-10/wr-accessory-riders', 'div-10/wr-partition-riders',
        "glazing", "glazing-riders",
        "project"
    ],
    groupFx: row => {
        if(row.kind === "quote-price-rider-create") {
            return getSectionKeyForRiders(row.sectionKey)
        }

        if(row.kind === "quote-price-rider" ) {
            const key = getSectionKeyForRiders(row.value.sectionKey as any);
            console.log("key", key)
            return key;
        }

        return getRowCategoryBase(row.value)
    },
    groupSorter: (a, b, aGroup, bGroup) => {
        if(a.startsWith("hardware/") && b.startsWith("hardware/")) {
            return bGroup.rows.length - aGroup.rows.length;
        }

        return prefixSort(a, b)
    },
    beforeGroup: BeforeGroup2,
    afterGroup: AfterGroup2,
    hasBeforeGroup: (group: Group<PriceRow>) => {
        if(group.key === "project") return false;
        if(group.key === "hardware-after") return false;
        if(group.key === "frame-totals") return false;
        if(group.key === "door-totals") return false;
        return true;
    },
    hasAfterGroup: (group: Group<PriceRow>) => {
        if(group.key === "hardware-before") return false;
        if(group.key.startsWith("hardware/")) return false
        return true;
    }
}

export function AddRider(props: {
    row: PriceRow
}) {
    const ctx = useContext(EditContext)
    const [show, setShow] = useState(false)
    const name = props.row.kind === "quote-price-rider" ? props.row.value.name : "";

    return (
        <div>
            {show && <EditRiderName onDone={async e => {
                await ctx.update(Object.assign({}, props.row, {
                    name: e,
                }))
                // merge refresh (not a full reload) so the table isn't hidden and
                // reshown -- a full reload resets the scroll position to the top
                ctx.reload(true);
                setShow(false);
            }} onCancel={() => setShow(false)} name={name} />}

            <button style={{paddingLeft: 16, background: "none", border: "none", cursor: "pointer"}} onClick={() => setShow(true)}>Add Rider</button>
        </div>
    );
}

function EditRiderName(props: {
    name: string;
    onDone(name: string): void;
    onArchive?(): void;
    onCancel(): void;
}) {
    const [value, setValue] = useState(props.name);
    return (
        <Dialog2 open={true} onClose={props.onCancel}>
            <DialogTitle>
                Rider
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <TextField label="Name" value={value} onChange={e => setValue(e.target.value)} />
            </DialogContent>
            <DialogActions>
                {props.onArchive && <Button onClick={props.onArchive} color="error">Archive</Button>}
                <div style={{flex: 1, minWidth: 40}} />
                <Button onClick={props.onCancel}>Cancel</Button>
                <Button variant="contained" onClick={() => props.onDone(value)}>Done</Button>
            </DialogActions>
        </Dialog2>
    )
}

export function RiderRowTitle(props: {
    row: PriceRow
}) {
    const ctx = useContext(EditContext)
    const [show, setShow] = useState(false)
    const row = props.row;
    if(row.kind !== "quote-price-rider") return null;
    const name = row.value.name;

    return (
        <div style={{
            display: "flex",
            flexDirection: 'row',
            alignItems: "center",
            height: 14,
            overflow: "hidden",
        }}>
            {show && <EditRiderName
                onDone={e => {
                    ctx.update(Object.assign({}, row, {
                        value: Object.assign({}, row.value, {
                            name: e,
                        })
                    }))
                    setShow(false)
                }}
                onArchive={async () => {
                    await ctx.update(Object.assign({}, row, {
                        value: Object.assign({}, row.value, {
                            archived: true,
                        })
                    }))
                    // merge refresh (not a full reload) so the table isn't hidden and
                    // reshown -- a full reload resets the scroll position to the top
                    ctx.reload(true)
                    setShow(false)
                }}
                onCancel={() => setShow(false)}
                name={name} />}

            <TableMoreBtn onClick={e => setShow(true)} />
            <div style={{width: 6}} />

            {name}
        </div>
    );
}

const prefixSort = byPrefix([
    "frame", "frame-prep", "frame-riders", "frame-totals",
    "door", "door-prep", "door-riders",
    "door-totals", "hardware-before", "hardware", "hardware-riders", "hardware-after", "div-10",
    "glazing", "glazing-riders", "project",
]);

export function getRowCategoryBase(row: PriceLine2 | PriceLine | QuotePriceLine, splitHardwareByMfg: boolean = true) {
    if(row.productType === "door") {
        if(row.door.series === hollowMetalDoor) return doorHm
        if(row.door.series === woodDoor) return doorWd
        return doorOther;
    }

    if(row.productType === "door-prep") {
        if(row.doorSeries === hollowMetalDoor) return "door-prep/hm"
        if(row.doorSeries === woodDoor) return "door-prep/wd"
        return "door-prep/other";
    }

    if(row.productType === "div-10") {
        return "div-10/" + (row.div10?.category || "wr-accessory");
    }

    if(row.productType === "hardware") {
        if(splitHardwareByMfg) {
            return "hardware/" + row.supplierName;
        }

        return "hardware";
    }

    return row.productType;
}

// recombineHardwareByProduct merges the hardware lines that quote_price now splits
// per supplier category back into one line per product (the pre-split grain) —
// summing qty and extended price and blending unit cost. Non-hardware lines pass
// through untouched. PDFs show hardware as one combined list, not split by category.
export function recombineHardwareByProduct(lines: QuotePriceLine[]): QuotePriceLine[] {
    const out: QuotePriceLine[] = [];
    const byKey = new Map<string, QuotePriceLine>();

    for(const line of lines) {
        if(line.productType !== "hardware") {
            out.push(line);
            continue;
        }

        const key = [line.product, line.itemName || "", line.doorSeries || "", line.frameSeries || ""].join(" ");
        const existing = byKey.get(key);
        if(!existing) {
            const copy = Object.assign({}, line, {linkedQuotePrice: [...(line.linkedQuotePrice || [])]});
            byKey.set(key, copy);
            out.push(copy);
            continue;
        }

        const totalQty = existing.qty + line.qty;
        const totalCost = existing.unitCostCents * existing.qty + line.unitCostCents * line.qty;
        existing.qty = totalQty;
        existing.extendedPrice = existing.extendedPrice + line.extendedPrice;
        existing.unitCostCents = totalQty > 0 ? Math.round(totalCost / totalQty) : existing.unitCostCents;
        existing.linkedQuotePrice = [...(existing.linkedQuotePrice || []), ...(line.linkedQuotePrice || [])];
        // a combined line no longer belongs to a single supplier category
        existing.rootSupplierCategory = null;
        existing.rootSupplierCategoryName = null;
    }

    return out;
}

export const commonGroupBy: GroupByProp<QuotePriceLine> = {
    fixedGroups: [
        "frame", "frame-anchor", "frame-prep", "frame-totals",
        "door-hm", "door-wd", "door-other", "door-prep", "door-totals",
        "hardware-before", "hardware-after",
        'div-10/corner-guard', 'div-10/locker', 'div-10/mailbox', 'div-10/wr-accessory', 'div-10/wr-partition',
        "project"
    ],
    groupFx: row => {
        return getRowCategoryBase(row)
    },
    groupSorter: (a, b, aGroup, bGroup) => {
        if(a.startsWith("hardware/") && b.startsWith("hardware/")) {
            return bGroup.rows.length - aGroup.rows.length;
        }

        return prefixSort(a, b)
    },
    beforeGroup: BeforeGroup,
    afterGroup: AfterGroup,
    hasBeforeGroup: (group: Group<QuotePriceLine>) => {
        if(group.key === "project") return false;
        if(group.key === "hardware-after") return false;
        if(group.key === "frame-totals") return false;
        if(group.key === "door-totals") return false;
        return true;
    },
    hasAfterGroup: (group: Group<QuotePriceLine>) => {
        if(group.key === "hardware-before") return false;
        if(group.key.startsWith("hardware/")) return false
        return true;
    }
}

export type PriceRow = {
    id: number
    defaultSort: number;
} & ({
    kind: "quote-price"
    value: QuotePriceLine
} | {
    kind: "quote-price-rider";
    value: QuotePriceRider;
} | {
    kind: "quote-price-rider-create";
    productType: string;
    sectionKey: SectionKey;
    name: string;
})

export type SectionKey = "frame"| "frame-anchor"| "frame-prep" | "frame-riders" | "frame-totals"|
    "door-hm"| "door-wd"| "door-other"| "door-prep" | "door-prep/wd" | "door-riders/hm" | "door-riders/wd" | "door-totals"|
    "hardware-before"| "hardware-after"|
    'div-10/corner-guard'| 'div-10/locker'| 'div-10/mailbox'| 'div-10/wr-accessory'| 'div-10/wr-partition'|
    "glazing" | "glazing-riders"

export const doorHm = "door-hm";
export const doorWd = "door-wd";
export const doorOther = "door-other";

function byPrefix(prefixes: string[]) {
    const matchIndex = (search: string) => {
        let matchedI = Infinity;
        let matchedLen = 0;

        // try to find exact match first, then prefix match by longest prefix
        for(let i = 0; i < prefixes.length; i++) {
            if(search === prefixes[i])
                return i;

            if(search.startsWith(prefixes[i])) {
                if(prefixes[i].length >= matchedLen) {
                    matchedLen = prefixes[i].length;
                    matchedI = i;
                } else {
                    // ignore b/c we have a longer prefix match already
                }
            }
        }

        if(matchedI < prefixes.length+1) {
            return matchedI;
        }

        return prefixes.length + 1;
    }

    return (a: string, b: string) => {
        return matchIndex(a) - matchIndex(b)
    }
}

export const materialCostColumnName = "Material Cost(ea)"
export function doorFrameCols() {
    return [
        PriceCol({
            name: materialCostColumnName,
            price: (dt) => {
                return renderCents(dt, "unitMaterialCostCents")
            },
            rider: (dt, row) => {
                return "";
            },
            sortPrice: (a, b) =>  sortNumericInner(a.unitMaterialCostCents, b.unitMaterialCostCents),
            sortRider: (a, b) =>  0,
            copy: (dt: PriceRow) => dt.kind === "quote-price" ? formatCents(dt.value.unitMaterialCostCents) : "",
            editableFunc: (dt: PriceRow) => {
                if(dt.kind === "quote-price") {
                    return {
                        editable: {
                            type: "number",
                            parseValue: centsParseValue,
                        },
                        editKey: "value.unitMaterialCostCents" as any,
                    }
                }

                return null;
            },
            filter: (input: PriceRow, search: string) => {
                if(!search) return true;
                if(input.kind !== "quote-price") return false;

                return (renderCents(input.value, "unitMaterialCostCents") || 0).toString().indexOf(search.trim()) !== -1
            },
            width: 80,
            alignRight: true,
        }),
        PriceCol({
            name: "In-House Cost(ea)",
            price: (dt) => {
                return renderCents(dt, "unitInHouseCostCents")
            },
            rider: (dt, row) => {
                return "";
            },
            sortPrice: (a, b) =>  sortNumericInner(a.unitInHouseCostCents, b.unitInHouseCostCents),
            sortRider: (a, b) =>  0,
            copy: (dt: PriceRow) => dt.kind === "quote-price" ? formatCents(dt.value.unitInHouseCostCents) : "",
            editableFunc: (dt: PriceRow) => {
                if(dt.kind === "quote-price") {
                    return {
                        editable: {
                            type: "number",
                            parseValue: centsParseValue,
                        },
                        editKey: "value.unitInHouseCostCents" as any,
                    }
                }

                return null;
            },
            filter: (input: PriceRow, search: string) => {
                if(!search) return true;
                if(input.kind !== "quote-price") return false;

                return (renderCents(input.value, "unitInHouseCostCents") || 0).toString().indexOf(search.trim()) !== -1
            },
            width: 80,
            alignRight: true,
        }),
    ]
}

function MyCheckboxEl(props: {
    value: boolean;
    row: PriceRow;
}) {
    const ctx = useContext(EditContext);
    const [active, setActive] = useState(false);

    if(active) {
        return (<div>...</div>)
    }

    return (
        <div
            style={{
                display: "flex", justifyContent: "center",
                fontSize: "0.9rem", cursor: "pointer",
                color: props.value ? blue["600"] : grey["300"],
                borderRadius: 5,
                position: "relative",
                marginLeft: -editCellPadding.left,
                marginRight: -editCellPadding.right,
                marginTop: -editCellPadding.top - 2,
                marginBottom: -editCellPadding.bottom - 2,
                height: 22,
                overflow: "hidden",
            }}
        >
            {/* This div is used to capture mouse events */}
            <div
                style={{
                    position: "absolute",
                    top: 0, left: 0, right: 0, bottom: 0,
                }}
                onClick={async () => {
                    setActive(true);

                    try {
                        if(props.row.kind !== "quote-price") return;

                        await ctx.update(Object.assign({}, props.row, {
                            value: Object.assign({}, props.row.value, {
                                stockOrder: !props.value,
                            })
                        }))
                    } finally {
                        setActive(false);
                    }
                }}
            ></div>
            {props.value ? <CheckBoxIcon/> : <CheckBoxOutlineBlankIcon/>}
        </div>
    )
}

const yesNoList = ["Yes", "No"];

export const commonPricingColumns2: (u: User, isQuote: boolean, proposing?: boolean) => (Column<PriceRow> | false)[] = (u: User, isQuote: boolean, proposing: boolean = false) => [
    PriceCol({
        name: "Stock",
        width: 100,
        price: (o, row) => {
            const selected = (lookupNestedProp(o, "stockOrder") as boolean)

            return (
                <MyCheckboxEl row={row} value={selected} />
            )
        },
        rider: (dt, row) => {
            return "";
        },
        renderFilter: (props) => {
            return (<SelectFilterForCol value={props.value} list={yesNoList} onChange={props.onChange} />)
        },
        filter: (row: PriceRow, input: string) => {
            if(!input) return true;
            if(row.kind !== "quote-price") return false;

            if(input === "yes") {
                return row.value.stockOrder;
            }

            if(input === "no") {
                return !row.value.stockOrder;
            }

            return true;
        },
        sortPrice: (a, b) => {
            if (a.stockOrder && !b.stockOrder) return -1;
            if (!a.stockOrder && b.stockOrder) return 1;
            return 0;
        },
    }),
    PriceCol({
        name: qtyColumnName,
        width: 100,
        alignRight: true,
        // @ts-ignore
        customizeKeepWhite: true,
        price: (o) => {
            const val = (lookupNestedProp(o, "qty") as any)
            if (!isQuote && val === 0) return "";
            return val?.toString()
        },
        rider: (dt, row) => {
            return dt.qty.toString();
        },
        editableFunc: (input: PriceRow) => {
            if (input.kind === "quote-price-rider") {
                return {
                    editable: {
                        type: "number",
                    },
                    editKey: "value.qty" as any,
                }
            }

            return null;
        },
        sortPrice: (a, b) => sortNumericInner(a.qty, b.qty),
        sortRider: (a, b) => sortNumericInner(a.qty, b.qty),
    }),
    PriceCol({
        name: costEachColumnName,
        price: (dt) => {
            return renderCents(dt, "unitCostCents")
        },
        rider: (dt, row) => {
            return formatCents(dt.unitCostCents)
        },
        sortPrice: (a, b) => sortNumericInner(a.unitCostCents, b.unitCostCents),
        sortRider: (a, b) => sortNumericInner(a.unitCostCents, b.unitCostCents),
        copy: (dt: PriceRow) => {
            if(dt.kind === "quote-price" || dt.kind === "quote-price-rider") {
                return formatCents(dt.value.unitCostCents)
            }

            return ""
        },
        editableFunc: (dt: PriceRow) => {
            if (dt.kind === "quote-price") {
                return {
                    editable: {
                        type: "number",
                        parseValue: centsParseValue,
                    },
                    editKey: "value.unitCostCents" as any,
                    showHintOnFocus: CostFocuser,
                }
            }

            if(dt.kind === "quote-price-rider") {
                return {
                    editable: {
                        type: "number",
                        parseValue: centsParseValue,
                    },
                    editKey: "value.unitCostCents" as any,
                }
            }

            return null;
        },
        width: 80,
        alignRight: true,
    }),

    PriceCol({
        name: markupColumnName,
        // @ts-ignore
        customizeKeepWhite: true,
        price: dt => {
            return renderMarkupPrice(dt)
        },
        rider: (dt, row) => {
            return renderMarkupRider(dt)
        },
        sortRider: (a, b) => sortStringInner(renderMarkupRider(a), renderMarkupRider(b)),
        sortPrice: (a, b) => sortStringInner(renderMarkupPrice(a), renderMarkupPrice(b)),
        editableFunc: (dt: PriceRow) => {
            if(dt.kind === "quote-price" || dt.kind === "quote-price-rider") {
                return {
                    editable: {
                        type: "custom",
                        copy: row => {
                            if(row.kind !== "quote-price" && row.kind !== "quote-price-rider") return "";
                            const dt = row.value;

                            if(!isNullOrUndefined(dt.markupPercent)) return dt.markupPercent + "%"
                            if(!isNullOrUndefined(dt.markupCents)) return "$" + formatCents(dt.markupCents)
                            return "auto"
                        },
                        paste: (row, value) => {
                            if(row.kind !== "quote-price" && row.kind !== "quote-price-rider") return;
                            const rw = row.value;

                            Object.assign(rw, parseMarkup(value))
                        },
                        render: MarkupEditCell2 as any,
                    },
                    editKey: "" as any,
                }
            }

            return null;
        },
        alignRight: true,
        width: 80,
    }),
    PriceCol({
        name: "Unit Price",
        // @ts-ignore
        customizeKeepWhite: true,
        sortPrice: (a, b) =>  sortNumericInner(getUnitPrice(a), getUnitPrice(b)),
        sortRider: (a, b) =>  0,
        price: dt => {
            return formatCents(getUnitPrice(dt))
        },
        rider: (dt, row) => {
            return ""
        },
        alignRight: true,
        width: 80,
    }),

    PriceCol({
        name: "Price",
        // @ts-ignore
        customizeKeepWhite: true,
        alignRight: true,
        width: 70,
        sortPrice: (a, b) =>  sortNumericInner(a.extendedPrice, b.extendedPrice),
        sortRider: (a, b) =>  sortNumericInner(a.extendedPrice, b.extendedPrice),
        copy: (dt: PriceRow) => {
            if(dt.kind === "quote-price" || dt.kind === "quote-price-rider") {
                return formatCents(dt.value.extendedPrice)
            }

            return ""
        },
        price: (dt) => {
            return formatCents(dt.extendedPrice)
        },
        rider: (dt) => {
            return formatCents(dt.extendedPrice)
        },
        editableFunc: (row: PriceRow) => {
            if(row.kind === "quote-price" || row.kind === "quote-price-rider") {
                return {
                    editable: {
                        type: "number",
                            parseValue: centsParseValue,
                    },
                    editKey: "value.extendedPrice" as any,
                }
            }

            return null;
        }
    }),


    hasPermission(u, "CanViewProjectPricingProfit") && PriceCol({
        name: "Proj. Profit",
        // @ts-ignore
        customizeKeepWhite: true,
        price: dt => {
            return formatCents(profit(dt))
        },
        rider: () => "",
        sortPrice: (a, b) =>  sortNumericInner(profit(a), profit(b)),
        alignRight: true,
        width: 90,
    }),

    hasPermission(u, "CanViewProjectPricingProfit") && PriceCol({
        name: "Act. Profit",
        // @ts-ignore
        customizeKeepWhite: true,
        price: dt => {
            return renderActualProfit(dt, false)
        },
        sortPrice: (a, b) =>  sortNumericInner(renderActualProfit(a, true) as any, renderActualProfit(b, true) as any),
        rider: () => "",
        alignRight: true,
        width: 90,
    }),
    PriceCol({
        name: "Proj. Margin",
        // @ts-ignore
        customizeKeepWhite: true,
        price: dt => {
            return renderProfitMargin(dt) + "%"
        },
        sortPrice: (a, b) =>  sortNumericInner(renderProfitMargin(a), renderProfitMargin(b)),
        rider: () => "",
        alignRight: true,
        width: 100,
    }),
    PriceCol({
        name: "Suggested Markup",
        // @ts-ignore
        customizeKeepWhite: true,
        price: dt => {
            return "35%"
        },
        rider: () => "",
        alignRight: true,
        width: 150,
    }),
]

function renderProfitMargin(dt: QuotePriceLine) {
    let profit = dt.extendedPrice - dt.unitCostCents * dt.qty;
    if(profit === 0) return 0
    let margin = Math.round(profit / dt.extendedPrice * 100);
    return margin
}

function renderActualProfit(dt: QuotePriceLine, numeric: boolean) {
    if(isNullOrUndefined(dt.revenueDelivered) || isNullOrUndefined(dt.costDelivered)) {
        if(numeric) {
            return 0;
        }

        return "";
    }

    if(numeric) {
        return dt.revenueDelivered - dt.costDelivered
    }

    return formatCents(dt.revenueDelivered - dt.costDelivered);
}

function renderMarkupRider(dt: QuotePriceRider) {
    if(!isNullOrUndefined(dt.markupPercent)) return dt.markupPercent + "%"
    if(!isNullOrUndefined(dt.markupCents)) return "$" + formatCents(dt.markupCents)
    return "auto"
}

function renderMarkupPrice(dt: QuotePriceLine) {
    if(!isNullOrUndefined(dt.markupPercent)) return dt.markupPercent + "%"
    if(!isNullOrUndefined(dt.markupCents)) return "$" + formatCents(dt.markupCents)
    return "auto"
}

function getUnitPrice(dt: QuotePriceLine) {
    return dt.extendedPrice / fixZero(dt.qty)
}

function fixZero(value: number) {
    if(value === 0) return 1;
    return value;
}

export function ViewPriceCol(name: string, key: string, width: number = 100) {
    return {
        name: name,
        width: width,
        render: (dt: PriceRow) => {
            if(dt.kind !== "quote-price") {
                return null;
            }

            return lookupNestedProp(dt.value, key as any)
        },
        filter: (row: PriceRow, search: string) => {
            if(search === "") return true;
            if(row.kind !== "quote-price") return false;

            const v = lookupNestedProp(row?.value, key as any)
            return v && v.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1;
        },
        sort: (a: PriceRow, b: PriceRow) => {
            if(a.kind === "quote-price" && b.kind === "quote-price") {
                return sortStringInner(lookupNestedProp(a.value, key as any) || "", lookupNestedProp(b.value, key as any) || "")
            }

            return makeSortValue(b.defaultSort - a.defaultSort);
        }
    }
}

export function ViewPriceDimCol(name: string, key: string, opts?: {
    width?: number
    renderInUnitSystem?: UnitSystem;
    // show the value in the small unit of the system (inches, mm) instead of feet+inches
    smallUnits?: boolean;
}) {

    const sys = opts?.renderInUnitSystem;
    const col = ViewPriceCol(name, key, opts?.width || 100);

    const render = (row: PriceRow) => {
        if(row.kind !== "quote-price") return "";

        const value = lookupNestedProp(row.value, key as any) || ""
        if(!sys) return value;

        if(opts?.smallUnits) {
            return formatSmallUnits(value, sys);
        }

        const uu = universalParser(value);
        if(sys === "metric") {
            return MetricDistance.fromUniversal(uu).toString();
        }

        return ImperialDistance.fromUniversal(uu).toString();
    }

    return Object.assign(col, {
        render: render,
        filter: (row: PriceRow, search: string) => {
            if(search === "") return true;
            if(row.kind !== "quote-price") return false;

            const v = render(row);
            return v && v.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1;
        },
        sort: (a: PriceRow, b: PriceRow) => {
            if(a.kind === "quote-price" && b.kind === "quote-price") {
                const aStr = lookupNestedProp(a.value, key as any) || ""
                const bStr = lookupNestedProp(b.value, key as any) || ""
                const aUniversal = universalParser(aStr);
                const bUniversal = universalParser(bStr);
                if(aUniversal < bUniversal) return -1;
                if(aUniversal > bUniversal) return 1;
                return 0;
            }

            return makeSortValue(b.defaultSort - a.defaultSort);
        }
    })
}

function makeSortValue(value: number) {
    if(value < 0) return -1;
    if(value > 0) return 1;
    return 0;
}

export function ViewPriceBoolCol(name: string, key: string, width: number = 100) {
    return {
        name: name,
        width: width,
        render: (dt: PriceRow) => {
            if(dt.kind !== "quote-price") return null;
            return lookupNestedProp(dt.value, key as any) ? "Yes" : "No"
        }
    }
}

export function PriceCol<TPrice = QuotePriceLine, TRider = QuotePriceRider>(props: {
    name: string;
    price?: (dt: TPrice, raw: any) => any;
    rider?: (dt: TRider, row: PriceRow) => any;
    createRider?: (row: PriceRow) => any;
    width: number;
    sortPrice?: (a: TPrice, b: TPrice) => 1 | 0 | -1;
    sortRider?: (a: TRider, b: TRider) => 1 | 0 | -1;
    renderFilter?: (props: RenderFilterProps) => any;
    filter?: (row: PriceRow, input: string) => boolean;
} & Partial<Column<PriceRow>>): Column<PriceRow> {
    const {price, sortPrice, sortRider, rider, ...others} = props

    return {
        ...others,
        sort: (a, b) => {
            if(a.defaultSort === b.defaultSort) {
                if(a.kind === "quote-price" && b.kind === "quote-price") {
                    if(sortPrice) {
                        return sortPrice(a.value as any, b.value as any)
                    }
                } else if(a.kind === "quote-price-rider" && b.kind === "quote-price-rider") {
                    if(sortRider) {
                        return sortRider(a.value as any, b.value as any)
                    }
                }
            }

            return makeSortValue(b.defaultSort - a.defaultSort);
        },
        render: (dt: PriceRow) => {
            if(dt.kind === "quote-price") {
                if(!price) return null
                return price(dt.value as any, dt)
            }

            if(dt.kind === "quote-price-rider") {
                if(!rider) return null
                return rider(dt.value as any, dt)
            }

            if(dt.kind === "quote-price-rider-create") {
                if(props.createRider) {
                    return props.createRider(dt as any)
                }
            }

            return null
        },
    }
}

export function profit2(row: PriceRow) {
    if(row.kind === "quote-price") {
        const dt = row.value;
        const qty = "qty" in dt ? dt.qty : 1;
        return dt.extendedPrice - dt.unitCostCents * qty
    }

    return 0;
}

export function profit(dt: PriceLine | MiscPrice | QuoteMiscPrice | QuotePriceLine| PriceLine2) {
    const qty = "qty" in dt ? dt.qty : 1;
    return dt.extendedPrice - dt.unitCostCents * qty
}

export function usePriceCellCustomize2() {
    return {
        backgroundColor: (row: PriceRow, c: Column<PriceRow>) => {
            if(row.kind === "quote-price-rider") {
                return blueGrey["50"]
            }

            return undefined;
        }
    }
}